/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { LuisId } from 'src/luis/types/Resource';
import { EntityLabelStore } from 'src/luis/types/stores/utterances/EntityLabelStore';

export type IntentScore = { intentId: LuisId; score: number };

export class PredictionStore {
    public readonly text: string;

    public readonly tokenizedText: string[];

    public readonly predictedEntities: EntityLabelStore[];

    public readonly predictedIntents: IntentScore[];

    @observable
    public isDirty = false;

    constructor(prediction: Partial<PredictionStore>) {
        this.text = prediction.text;
        this.tokenizedText = prediction.tokenizedText;
        this.predictedEntities = prediction.predictedEntities;
        this.predictedIntents = prediction.predictedIntents;
    }

    @action
    public setIsDirty(val: boolean) {
        this.isDirty = val;
    }
}
